(() => {
  const triggerSelector = '.testimonial-card--has-popup';
  const closeSelector = '[data-testimonial-popup-close]';
  const openClass = 'testimonial-popup--open';
  let activePopup = null;
  let activeTrigger = null;

  function getFocusableElements(container) {
    return Array.from(container.querySelectorAll([
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(','))).filter((element) => element.offsetParent !== null);
  }

  function openPopup(trigger) {
    const popupId = trigger.getAttribute('aria-controls');
    const popup = popupId ? document.getElementById(popupId) : null;

    if (!popup) {
      return;
    }

    if (activePopup) {
      closePopup();
    }

    activePopup = popup;
    activeTrigger = trigger;

    popup.classList.add(openClass);
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('testimonial-popup-is-open');

    const focusableElements = getFocusableElements(popup);
    const closeButton = popup.querySelector(closeSelector);
    (closeButton || focusableElements[0] || popup).focus();
  }

  function closePopup() {
    if (!activePopup) {
      return;
    }

    activePopup.classList.remove(openClass);
    activePopup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('testimonial-popup-is-open');

    if (activeTrigger) {
      activeTrigger.focus();
    }

    activePopup = null;
    activeTrigger = null;
  }

  function keepFocusInPopup(event) {
    if (!activePopup || event.key !== 'Tab') {
      return;
    }

    const focusableElements = getFocusableElements(activePopup);

    if (!focusableElements.length) {
      event.preventDefault();
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  document.addEventListener('click', (event) => {
    const closeElement = event.target.closest(closeSelector);

    if (closeElement) {
      event.preventDefault();
      closePopup();
      return;
    }

    const trigger = event.target.closest(triggerSelector);

    if (trigger) {
      event.preventDefault();
      openPopup(trigger);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closePopup();
      return;
    }

    keepFocusInPopup(event);

    const trigger = event.target.closest(triggerSelector);

    if (!trigger || (event.key !== 'Enter' && event.key !== ' ')) {
      return;
    }

    event.preventDefault();
    openPopup(trigger);
  });
})();
